import React from 'react';
import { TfiMenuAlt } from 'react-icons/tfi';
import AdminProfile from '../pages/Profile';

const Navbar = ({ toggleSidebar }) => {
    return (
        <header
            className="w-full  text-[--text-color-g]  flex border-b items-center justify-between px-4 py-3"
            id="primary-fonts"
        >
            {/* Left section with toggle and title */}
            <div className="flex items-center space-x-4">
                {/* Sidebar Toggle Button - Always visible */}
                <button
                    onClick={toggleSidebar}
                    className="focus:outline-none text-[--primary-btn-color]"
                    aria-label="Toggle Sidebar"
                >
                    <TfiMenuAlt className="w-6 h-6 md:w-8 md:h-8" />
                </button>

                {/* Title */}
                <h1 className="text-xl text-[--font-color] font-semibold">
                    Urdu Ustaad Dashboard
                </h1>
            </div>

            {/* Right section with icons */}
            <div className="flex items-center gap-3 md:gap-4">
                <div className="flex items-center gap-4">
                    <AdminProfile />
                </div>
            </div>
        </header>
    );
};

export default Navbar;